"use strict";

var _classCallCheck = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _assertThisInitialized = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _wrapNativeSuper = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/wrapNativeSuper");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var InvalidJsonError = /*#__PURE__*/function (_Error) {
  _inherits(InvalidJsonError, _Error);

  var _super = _createSuper(InvalidJsonError);

  function InvalidJsonError(streamId, jsonString, parseError, streamMessage) {
    var _this;

    _classCallCheck(this, InvalidJsonError);

    _this = _super.call(this, "Invalid JSON in stream ".concat(streamId, ": ").concat(jsonString, ". Error while parsing was: ").concat(parseError));
    _this.streamId = streamId;
    _this.jsonString = jsonString;
    _this.parseError = parseError;
    _this.streamMessage = streamMessage;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this), _this.constructor);
    }

    return _this;
  }

  return InvalidJsonError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.default = InvalidJsonError;